import styled, { css, keyframes } from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';
import { theme } from '@marriott/mi-ui-library-shop';

const slideIn = keyframes`
  from {
    right: -100%;
  }
  to {
    right: 0;
  }
`;

const slideOut = keyframes`
  from {
    right: 0;
  }
  to {
    right: -100%;
  }
`;

export const StyledSignInDrawer = styled.div`
  [role='dialog'] {
    height: 100dvh;
    overflow-y: auto;
  }

  .signout {
    font-weight: 700px !important;
    letter-spacing: 0.071875rem;
    border-bottom: none;
    line-height: 1.1875rem;
    margin-top: 40px !important;
    font-weight: 700 !important;
  }
  .signin-drawer .separator {
    color: var(--t-brand-fg-color);
    margin-block: inherit;
    border-bottom: 0px;
    margin-top: 42px;
    width: 100%;
    @media screen and (min-width: 992px) {
      margin-top: 42px;
    }
  }
  .signin-drawer h4 {
    max-width: none;
    min-width: auto;
  }
  .signin-drawer {
    @media screen and (max-width: 992px) {
      padding-bottom: 50px;
    }
    h4.points {
      font-weight: 700 !important;
    }
  }
  .listCollection {
    list-style: none;
    li {
      &::marker {
        content: '';
      }
    }
    .listClassName {
      font-size: ${toRem(16)};
      line-height: ${toRem(19)};
      &:hover {
        border-bottom-width: ${toRem(1)};
        padding-bottom: ${toRem(1.5)};
        border-bottom: 0 !important;
        @media ${theme.mediaQuery.desktop} {
          border-bottom: 0.125rem solid #1c1c1c !important;
        }
      }
    }
  }
  .points {
    color: #1c1c1c !important;
  }

  .signin-drawer .listCollection .listClassName {
    font-size: ${toRem(16)} !important;
    line-height: ${toRem(19)} !important;
    font-weight: 700 !important;
    color: #1c1c1c !important;
  }
  .buypointsbutton {
    border-radius: 52px !important;
    line-height: normal !important;
    font-weight: 700 !important;
  }
  a.buypointsbutton {
    color: #ffffff !important;
    @media screen and (max-width: 992px) {
      padding-top: 0px !important;
    }
    background-color: #000000 !important;
    &:hover {
      opacity: 0.8;
    }
  }
`;

export const AccountDrawer = styled.div<{ isOpen: boolean }>`
  position: fixed;
  inset: 0;
  z-index: ${({ isOpen }) => (isOpen ? 999 : -1)};
  background: ${({ isOpen }) => (isOpen ? `rgba(28, 28, 28, 0.56)` : `rgba(28, 28, 28, 0)`)};
  pointer-events: ${({ isOpen }) => (isOpen ? 'auto' : 'none')};
  transition: background-color 0.3s ease;
`;

export const StyledAccountPanel = styled.div<{ isOpen: boolean }>`
  position: fixed;
  height: 100vh;
  top: 0;
  right: -100%;
  background-color: ${baseVariables.color['base20']};
  z-index: 1000;
  overflow: auto;
  width: 100vw;
  border-top: 0.25rem solid #1c1c1c;
  margin-top: 0;
  background-color: #eee;

  @media ${baseVariables.mediaQuery.sm} {
    width: ${toRem(364)};
  }
  @media ${baseVariables.mediaQuery.lg} {
    width: ${toRem(440)};
  }

  ${props =>
    props.isOpen &&
    css`
      animation: ${slideIn} 0.3s forwards;
    `}

  ${props =>
    !props.isOpen &&
    css`
      animation: ${slideOut} 0.3s forwards;
    `}
    .signout {
    color: #1c1c1c !important;
    font-weight: 700px !important;
    letter-spacing: ${toRem(1.15)};
    border-bottom: none;
    line-height: ${toRem(19)};
    background: none;
    margin-top: 24px !important;
    font-weight: 700 !important;
    color: #b94600 !important;
    margin-bottom: 60px !important;

    .signoutLabel :hover {
      border-bottom: ${toRem(1)} solid ${baseVariables.color['alert40']};
    }
  }
  .closeButton {
    background-color: none;
    border: 3px solid;
    border-radius: 50px;
    margin: 1rem;
    padding: 0.25rem;
  }

  .m-link-tertiary-button:after {
    line-height: 0.9rem !important;
  }
  .m-link-user {
    font: normal normal 700 1.875rem / 2.8125rem Swiss-721 !important;
    color: #1c1c1c !important;
  }
`;

export const StyledUserProfileImageContainer = styled.div<{ borderColor: string }>`
  width: ${toRem(100)};
  height: ${toRem(100)};
  margin-bottom: ${toRem(8)};
  @media ${baseVariables.mediaQuery.lg} {
    width: ${toRem(156)};
    height: ${toRem(156)};
  }

  .userprofile-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
    border: ${toRem(4)} solid ${props => props.borderColor};
    @media ${baseVariables.mediaQuery.lg} {
      border: ${toRem(7)} solid ${props => props.borderColor};
    }
  }

  .icon-lifetime {
    position: absolute;
    right: ${toRem(72)};
    bottom: ${toRem(4)};
    transform: rotate(-23deg);
    background: ${baseVariables.color['goldSolid']};
    color: ${baseVariables.color['base20']};
    border: ${toRem(3)} solid ${baseVariables.color['base20']};
    border-radius: 50%;
    width: ${toRem(32)};
    height: ${toRem(32)};
    font-size: ${toRem(20)};
    @media ${baseVariables.mediaQuery.lg} {
      width: ${toRem(40)};
      height: ${toRem(40)};
      font-size: ${toRem(27)};
      right: ${toRem(113)};
    }
  }
`;
